import React from 'react'

const ComputerIcon = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="computer-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(150, 100, 255, 1)" />
          <stop offset="100%" stopColor="rgba(100, 150, 255, 1)" />
        </linearGradient>
        <filter id="computer-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <rect 
        x="2" 
        y="3" 
        width="20" 
        height="14" 
        rx="2" 
        stroke="url(#computer-gradient)" 
        strokeWidth="2"
        filter="url(#computer-glow)"
      />
      <path 
        d="M8 21H16M12 17V21M6 13L18 13" 
        stroke="url(#computer-gradient)" 
        strokeWidth="2" 
        strokeLinecap="round"
        filter="url(#computer-glow)"
      />
      <circle cx="12" cy="9" r="2" fill="url(#computer-gradient)" opacity="0.5" />
      <rect x="7" y="7" width="2" height="1" rx="0.5" fill="url(#computer-gradient)" opacity="0.7" />
      <rect x="15" y="7" width="2" height="1" rx="0.5" fill="url(#computer-gradient)" opacity="0.7" />
    </svg>
  )
}

export default ComputerIcon
